import { createSelector } from 'reselect';

const constructionSelector = (state) => state.Construction;

const ORDERED_GATE_TYPES = [
  'swing_gate',
  'double_leaf_gate',
  'sectional_gate',
  'roller_gate'
];

export default createSelector(
  constructionSelector,
  (construction) => {
    const gates = construction?.gates?.gates || [];
    const present = new Set(
      gates
        .map((g) => g?.type)
        .filter(Boolean)
    );

    const gateTypesPresent = ORDERED_GATE_TYPES.filter((t) => present.has(t));

    return {
      loaded: construction.parameters_loaded,
      available: construction.available?.gates_pressing || [],
      info: construction.info?.gates_pressing || null,

      translations: construction.translations || {},

      gateTypesPresent,

      selectedByType: {
        swing_gate: construction.selected?.gates_pressing_swing_gate ?? null,
        double_leaf_gate: construction.selected?.gates_pressing_double_leaf_gate ?? null,
        sectional_gate: construction.selected?.gates_pressing_sectional_gate ?? null,
        roller_gate: construction.selected?.gates_pressing_roller_gate ?? null
      },

      selectedColorByType: {
        swing_gate: construction.selected?.gates_swing_color ?? null,
        double_leaf_gate: construction.selected?.gates_double_leaf_color ?? null,
        sectional_gate: construction.selected?.gates_sectional_color ?? null,
        roller_gate: construction.selected?.gates_roller_color ?? null
      },

      colorsAvailableColors: construction.colorsPressings?.colors || {}
    };
  }
);
